import axios from "axios";

export const photo = axios.create({
  baseURL: 'https://struct-hotel-api.herokuapp.com'
})